// initial state
const state = {
  status: {
    1: '新创建',
    2: '进行中',
    3: '已完成'
  },
  callStatus: {
    1: '待呼叫',
    2: '不呼叫',
    3: '已接通',
    4: '未接通',
    5: '失败',
  },
  recordStatus: {
    1: '等待通知',
    2: '接通',
    3: '未接通',
    4: '拨打失败',
  }
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const intelligentOutboundCall = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/intelligent-outbound-call/intelligent-outbound-call.store.js